import SvgIcon from '@material-ui/core/SvgIcon';

export default function Undo(props:any) {
  return (
    <SvgIcon  viewBox="0 0 16 18" {...props}>
      <path d="M6.5 15.9429H14V18H6.5C2.91 18 0 15.0069 0 11.3143C0 7.62171 2.91 4.62857 6.5 4.62857H12.17L9.08 1.45029L10.5 0L16 5.65714L10.5 11.3143L9.09 9.864L12.17 6.68571H6.5C4 6.68571 2 8.74286 2 11.3143C2 13.8857 4 15.9429 6.5 15.9429Z" fill="currentColor"/>
    </SvgIcon>
  );
}

